<template>
  <div class="login-container">

    <div class="login-form">
      <div class="login-welcome">欢迎登录</div>
      <div class="login-text">{{$store.state.settings.title}}</div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        auto-complete="on"
        label-position="left"
        class="box-form"
      >
        <el-form-item prop="username">
          <el-input
            ref="username"
            v-model="loginForm.username"
            placeholder="请输入您的账号"
            name="username"
            type="text"
            tabindex="1"
            auto-complete="on"
          >
          <!-- <i slot="prefix" class="el-input__icon el-icon-user-solid" style="color:transparent;border-width:1px;border-style:soild;border-color:rgb(153, 153, 153)"></i> -->
          <template #prefix style="display:flex;align-items:center"><div  class="prefix" style="display:flex;align-items:center;height:100%;padding-left: 3px;"><img src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/yunzhishou-web/login_user.png" style="width:15px;height:17px" alt=""></div></template>
            <!-- <svg-icon
              slot="prefix"
              icon-class="user"
            /> -->
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            class="box-input"
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入您的密码"
            name="password"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          >
          <template #prefix style="display:flex;align-items:center"><div class="prefix" style="display:flex;align-items:center;height:100%;padding-left: 3px;"><img src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/yunzhishou-web/login_pwd.png" style="width:17px;height:17px" alt=""></div></template>
            <!-- <svg-icon
              slot="prefix"
              style="left: 10px;"
              icon-class="password"
            /> -->
            <svg-icon
              slot="suffix"
              @click="showPwd"
              :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'"
            />
          </el-input>
        </el-form-item>
        <el-button
          class="box_button"
          :loading="loading"
          type="primary"
          style="width:100%;margin-top:40px;"
          @click.native.prevent="handleLogin"
        >登录
        </el-button>
      </el-form>
      <!-- <div class="box box-item1"></div>
      <div class="box box-item2"></div>
      <div class="box box-item3"></div>
      <div class="box box-item4"></div> -->
    </div>

  </div>
</template>

<script>
import {validUsername} from '@/utils/validate'
import {setEnum} from '@/utils/localStorage'
import {findEnumConstant} from "@/api/common/enumConstant";

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error('请输入正确的用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能少于6位'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{required: true, trigger: 'blur', validator: validateUsername}],
        password: [{required: true, trigger: 'blur', validator: validatePassword}]
      },
      loading: false,
      passwordType: 'password',
      redirect: 'home'
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm).then(() => {
            findEnumConstant().then(resp => {
              setEnum(resp.data)
            })
            this.$router.push({path: this.redirect || '/home'})
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  }

}
</script>
<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  padding: inherit;
  background-image: url(../../../../public/login_bg2.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 1920px;

  .login-form {
    width: 500px;
    height: 440px;
    padding: 60px;
    box-sizing: border-box;
    position: fixed;
    // top: 270px;
    // right: 333px;
    top: 50%;
    left: 65%;
    // margin-left: -100px;
    color: rgb(5, 22, 36);
    // border-radius: 24px;
    // box-shadow: 2px 0 12px 0;
    margin-top: -280px !important;
    background: transparent !important;
    // border: 5px solid #d2f5fb !important
    .login-welcome {
      width: 100%;
      display: flex;
      justify-content: center;
      color: rgb(5, 22, 36);
      font-family: 微软雅黑;
      font-size: 24px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    .login-text {
      color: rgb(5, 22, 36);
      font-family: 微软雅黑;
      font-size: 20px;
      font-weight: 400;
      text-align: center;
    }
    .box-form {
      padding-top: 50px;
      ::v-deep .el-input__inner {
        border-color: transparent !important;
        border-radius: 4px;
        background: rgb(233, 233, 233);
        opacity: 0.78;
        color:rgb(5, 22, 36) !important;
        //caret-color: #bad6ec !important;
      }
      ::v-deep input:-webkit-autofill {
        /* 字体颜色，需要设置，否则会变成黑色 */

        -webkit-text-fill-color: rgb(5, 22, 36) !important;

        /* 变成透明背景色的固定写法，只针对表单自动填充的背景色 */

        transition: background-color 5000s ease-in-out 0s;
      }
      ::v-deep input::-webkit-input-placeholder {
        color: rgb(153, 153, 153);
      }
      .box_button {
        background: #00bfd5 !important;
        border-color: #00bfd5;
      }
      :deep(.el-input__wrapper){
        padding: 0.1vh 1.5vh  0.1vh 3.5vh;
        .el-input_inner{
          padding-left: 2vh !important;
        }
      }
    }

    .box {
      // z-index: 2500;
      position: absolute;
      width: 25px;
      height: 25px;
      // border: 2px solid #00bfd5;
    }
    .box-item1 {
      top: -2px;
      left: -2px;
      border-right: none;
      border-bottom: none;
      // border-top-left-radius: 6px;
    }
    .box-item2 {
      top: -2px;
      right: -2px;
      border-left: none;
      border-bottom: none;
      // border-top-right-radius: 6px;
    }
    .box-item3 {
      bottom: -2px;
      left: -2px;
      border-right: none;
      border-top: none;
      // border-bottom-left-radius: 6px;
    }
    .box-item4 {
      bottom: -2px;
      right: -2px;
      border-left: none;
      border-top: none;
      // border-bottom-right-radius: 6px;
    }
  }
}
</style>